import { styled } from '@mui/material/styles';

export const Root = styled('div')(() => ({
	position: 'relative',
	overflow: 'hidden',
}));

export const StyledImg = styled('img')(() => ({
	width: '100%',
	height: '100%',
	objectFit: 'cover',
	transition: 'opacity 0.6s ease',
}));

export const StyledImgPlaceholder = styled('img')(() => ({
	position: 'absolute',
	width: '100%',
	height: '100%',
	filter: 'blur(20px)',
	transform: 'scale(1.1)',
	transition: 'opacity 0.6s ease',
	objectFit: 'cover',
}));
